import { useQuery } from "@tanstack/react-query";
import { useState, useMemo } from "react";
import { HttpAFOCL } from "../api/httoAFOCL";
import { OperacionAFOCLTablaValorHistoricoGrupo } from "../types/dto";
import { OperacionAFOCLTablaValorHistoricoFields } from "../types/fields";
import { pivotAFOCLData } from "./useTablaValorAFOCL";

export const useAFOCLHistorico = (idOperacion: number | undefined | null) => {
  const [versionIndex, setVersionIndex] = useState<number>(0);

  const {
    data: versiones = [],
    isLoading,
    isError,
    error,
    refetch
  } = useQuery<OperacionAFOCLTablaValorHistoricoGrupo[], Error>({
    queryKey: ['AFOCL-historico-tabla', idOperacion],
    queryFn: () => HttpAFOCL.getTablaValoresHistorico(idOperacion!),
    enabled: !!idOperacion
  });

  const versionActual = versiones[versionIndex];

  const pivotData = useMemo(() => {
    const celdas = versionActual?.[OperacionAFOCLTablaValorHistoricoFields.Celdas] || [];
    
    return pivotAFOCLData(celdas);
  }, [versionActual]);

  return {
    versiones,
    versionActual,
    versionIndex,
    setVersionIndex,
    headers: pivotData.headers,
    rows: pivotData.rows,
    isLoading,
    isError,
    error,
    refetch
  };
};